<template>
    <div class="container-fluid">
        <b-card no-body bg-variant="dark">
            <span v-if="loading">
            <b-spinner label="Spinning"></b-spinner>
            </span>
            <span v-else>
                <b-tabs pills card vertical fill class="container-fluid align-top p-0">
                    <b-tab :title="$t('device_configuration.configuration')" active>
                        <b-card no-body class="border-0" bg-variant="dark">
                            <Passport
                                :id="deviceId"
                                :is-active="parametersData.isActive"
                                :is-default="parametersData.isDefault"
                                :description="parametersData.description"
                                :name="parametersData.name"
                            />
                        </b-card>
                    </b-tab>

                <b-tab :title="$t('settings.device_settings')" disabled no-body>{{$t('settings.device_settings')}}</b-tab>
                    <b-tab no-body
                            v-for="section in configuration.sectionList"
                            :key="section.id"
                            :title=section.name
                            :suffix="section.id"
                    >
                        <template v-slot:title>

                            <div class="d-flex">
                              <span class="ml-3">{{section.name}}</span>
                                  <span v-if="section.errors > 0" class="fa-stack ml-auto">
                                  <span style="color: red">
                                    {{section.errors}}
                                </span>

                              </span>
                            </div>
                        </template>
                        <b-card no-body class="border-0" bg-variant="dark">
                            <SettingsSection
                                :section="section"
                                :configuration="configuration"
                                :device-settings="deviceSettings"
                                :url="'api/v1/saved-configurations/' + id + '/settings'"
                                v-on:save:settings="saveSettings($event)"
                                v-on:update:settings="updateSettings($event)"
                                v-on:update:changed="saveChanged($event)"
                                :changed="changed"
                                :show-success-alert.sync="showSuccessAlert"
                            />
                        </b-card>
                    </b-tab>
                </b-tabs>
            </span>
        </b-card>
    </div>
</template>

<script>
    import Passport from "./Passport.vue";
    import axios from "axios";
    import SettingsSection from "../Common/Settings/Section";


    export default {
        name: "SaveConfigSettings",
        components: {SettingsSection, Passport},
        props: [
            "deviceId",
            "parameters",
            "deviceTypeId",
            "settings",
            "id"
        ],
        data() {
            return {
                loading: true,
                configuration: {
                    sectionList: [],
                    settingViewList: {},
                    settingDictionaryList: {},
                    sectionErrorList: {},
                    hasErrors() {
                        return this.sectionList.some(section => section.errors > 0);
                    }
                },
                parametersData: {
                    isActive: false,
                    isDefault: false,
                    description: null,
                    name: null
                },
                deviceSettings: {},
                changed: false,
                showSuccessAlert: false
            }
        },
        mounted() {
           let props = this;

            axios
                .get('api/v1/device-types/'+ props.deviceTypeId + '/configuration?_locale=' + this.lang)
                .then((resp) => {
                    const response = resp.data.data;
                    this.configuration.sectionList = response.sectionList.map(section => ({ ...section, errors: 0 }));

                    response.settingViewList.forEach(
                        settingView => {
                            this.configuration.settingViewList[settingView.alias] = {
                                alias: settingView.alias,
                                defaultValue: settingView.defaultValue,
                                textAfter: settingView.textAfter,
                                textBefore: settingView.textBefore,
                                type: settingView.type,
                                widget: settingView.widget,
                                readonly: settingView.readonly === true,
                                hint: settingView.hint,
                                rules: {}
                            };
                        }
                    )

                    response.settingDictionaryList.forEach(
                        settingViewDictionary => {
                            let items = [];

                            settingViewDictionary.items.forEach(
                                item => {
                                    items.push({
                                        item: item.number,
                                        name: item.name,
                                        notEnabled: item.notEnabled === true,
                                        hint: item.hint
                                    })
                                }
                            )
                            if (this.configuration.settingViewList[settingViewDictionary.settingView] !== null) {
                                this.configuration.settingViewList[settingViewDictionary.settingView].dictionary = items;
                            }
                        }
                    )

                    response.settingValidationRuleList.forEach(
                        settingValidationRuleList => {
                            let rules = {};

                            settingValidationRuleList.rules.forEach(
                                item => {
                                    switch (item.type) {
                                        case 'regexp':
                                            rules.regex = item.properties.regexp;
                                            break;
                                        case 'number':
                                            rules.between = {
                                                min: item.properties.min,
                                                max: item.properties.max
                                            };
                                            break;
                                        case 'dns_ip':
                                            // eslint-disable-next-line
                                            rules.regex = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^(?:(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){6})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:::(?:(?:(?:[0-9a-fA-F]{1,4})):){5})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){4})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,1}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){3})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,2}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:(?:[0-9a-fA-F]{1,4})):){2})(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,3}(?:(?:[0-9a-fA-F]{1,4})))?::(?:(?:[0-9a-fA-F]{1,4})):)(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,4}(?:(?:[0-9a-fA-F]{1,4})))?::)(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9]))\.){3}(?:(?:25[0-5]|(?:[1-9]|1[0-9]|2[0-4])?[0-9])))))))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,5}(?:(?:[0-9a-fA-F]{1,4})))?::)(?:(?:[0-9a-fA-F]{1,4})))|(?:(?:(?:(?:(?:(?:[0-9a-fA-F]{1,4})):){0,6}(?:(?:[0-9a-fA-F]{1,4})))?::))))$/
                                            break;
                                        case 'maxlength':
                                            rules.max = item.properties.value;
                                            break;
                                        case 'required':
                                            rules.required = true;
                                            break;
                                    }

                                    // rules.push({
                                    //     type: item.type,
                                    //     name: item.name,
                                    //     properties: item.properties
                                    // })
                                }
                            )
                            if (
                                this.configuration.settingViewList[settingValidationRuleList.setting_view_alias] !== null
                            ) {
                                this.configuration.settingViewList[settingValidationRuleList.setting_view_alias].rules = rules;
                                //console.log(items)
                            }
                        }
                    )
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.$emit('load-error', error);
                });

            props.settings.forEach(
                item => {
                    this.deviceSettings[item.alias] = item.value;
                }
            );

            this.parametersData.isActive = props.parameters.isActive
            this.parametersData.isDefault = props.parameters.isDefault
            this.parametersData.description = props.parameters.description
            this.parametersData.name = props.parameters.name

            // axios
            //     .get('api/v1/devices/'+ props.deviceImei + '/settings')
            //     .then((resp) => {
            //         const response = resp.data.data;
            //         response.forEach(
            //             item => {
            //                 this.deviceSettings[item.alias] = item.value;
            //             }
            //         );
            //
            //         this.loading = false;
            //     });
        },
        methods: {
            saveChanged() {
                this.changed = true
            },
            updateSettings(formData) {
                for (let setting in formData) {
                    this.deviceSettings[setting] = formData[setting].value;
                }
                // console.log(formData)
                // console.log(this.deviceSettings)
            },
            saveSettings() {
                // console.log(this.deviceSettings)

                if (this.configuration.hasErrors()){
                    alert('errors');
                    return;
                }

                let settings = [];

                for (let alias in this.deviceSettings) {
                    settings.push({alias: alias, value: this.deviceSettings[alias]})
                }

                const data = {'settings': settings};
                this.showSuccessAlert = false;

                axios
                    .post('api/v1/saved-configurations/' + this.id + '/settings', data)
                    .then(() => {
                        // console.log(response + undefined);
                        this.showSuccessAlert = true
                    })
                    .catch(error => {

                        console.log(error);
                        this.$bvModal.show('bv-modal-settings-save-error')
                    })

            }
        },
        computed: {
            lang : {
                get() {
                    return this.$store.getters.getLang
                },
            }
        }
    }
</script>

<style scoped>

</style>